// import React, { useState, useMemo } from "react";
// import { MdEdit, MdDelete } from "react-icons/md";
// import { PropertiesStore } from "../../Store/PagesStore/properties";
// import Table from "../Common/Table/main";
// import PropertyForm from "../Popups/propertiesPopup";
// import Dropdown from "../Common/Dropdown/main";
// import SearchBar from "../Common/SearchBar/main";
// import Pagination from "../Pagination/main";
// import { TriggerStore } from "../../Store";
// import { Popup } from "../Common/Popup/main";
// import { TenantsStore } from "../../Store/PagesStore/tenents";
// import TenantForm from "../Popups/tenantsPopup";
// import { UserStore } from "../../Store/PagesStore/users";
// import UserForm from "../Popups/users";
// import DeletePopup from "../Popups/deletePopup";
// import { useUsers } from "../../hook/useUsers";
// import { User } from "../../hook/types/users";

// type UserInfo = {
//   userName: string;
//   active: boolean;
//   userID: string;
//   contactNumber: string;
//   emailID: string;
//   role: string;
//   address: string;
//   createdBy: string;
//   password: string;
// };

// const EditAndDeleteButton: React.FC<{
//   onEdit: () => void;
//   onDelete: () => void;
// }> = ({ onEdit, onDelete }) => {
//   return (
//     <div className="flex space-x-2">
//       <button className="btn btn-secondary" onClick={onEdit}>
//         <MdEdit className="h-5 w-5 hover:text-primary" />
//       </button>
//       <button className="btn btn-danger" onClick={onDelete}>
//         <MdDelete className="h-5 w-5 hover:text-red-500" />
//       </button>
//     </div>
//   );
// };

// const UsersCard: React.FC = () => {


//   const  {Users,addUser,deleteUser,updateUser}  =  useUsers()
//   const { sidebarAction, sidebartrigger } = TriggerStore((state) => state);
//   const {editUser, } = UserStore((state) => state);

//   const [openPopup, setOpenPopup] = useState(false);
//   const [DeletPopup, setDeletPopup] = useState(false);
//   const [activeId, setActiveId] = useState<number>(0);
//   const [isActive, setIsActive] = useState(true);
//     const [isDelete, setIsDelete] = useState<boolean>(false);
//   const [addUserStatus, setAddUser] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [selectedUsers, setSelectedUsers] = useState<User | null>(null);

//   const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
//   // Sample data for demonstration
//   const sampleData = Array.from({ length: 100 }, (_, index) => ({
//     id: index + 1,
//     name: `Item ${index + 1}`,
//     description: `This is the description for item ${index + 1}`,
//   }));

//   // State for pagination
//   const [currentPage, setCurrentPage] = useState(0);
//   const [itemsPerPage, setItemsPerPage] = useState(10);

//   // Calculate total items and the current items to display
//   const totalItems = sampleData.length;
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = sampleData.slice(indexOfFirstItem, indexOfLastItem);
//   const columns = [
//     { key: "userName", title: "User Name", type: "text" },
//     { key: "userID", title: "User ID", type: "text" },
//     { key: "userContact", title: "Contact Number", type: "text" },
//     { key: "userEmail", title: "Email ID", type: "email" },
//     { key: "role", title: "Role", type: "text" },
//  //    { key: "userActiveInactive", title: "Status", type: "boolean" }, 
//     // { key: "address", title: "Address", type: "text" },
//     { key: "userPassword", title: "Password", type: "password" },
//     { key: "actions", title: "Actions", type: "component" },
//   ];


//   const UsersData = Users({ isActive: isActive,delete: isDelete, page: currentPage, size: itemsPerPage });

//   const handleEdit = (user: User) => {
//     setAddUser(false)
//     setSelectedUsers(user);
//     setOpenPopup(true);
//   };

//   const handleDelete = async() => {
//     await deleteUser.mutateAsync(activeId).then(() =>{
//       setDeletPopup(false);

//     });
//   };

//   const handleSubmit = async (formData: User) => {
//     try {      
//       if (addUserStatus) {
        
//         await addUser.mutateAsync({
//           userContact: formData.userContact,
//           userEmail: formData.userEmail,
//           userName: formData.userName,
//           userPassword: formData.userPassword,
//           roles: formData.roles[0].roleName,
//           //userActiveInactive: true,
//            userActiveInactive: formData.userActiveInactive, 
//         });
  
//         setAddUser(false);
//         setOpenPopup(false);
//       } else {
        
//         await updateUser.mutateAsync({
//           id: formData.userID as any,
//           updatedUser: {
//             userContact: formData.userContact,
//             userEmail: formData.userEmail,
//             userName: formData.userName,
//             userPassword: formData.userPassword,
//             roles: formData.roles[0].roleName,
//             userActiveInactive: formData.userActiveInactive,
//           },
//         });
  
//         setOpenPopup(false);
//       }
  
//       setAddUser(false);
//     } catch (error) {
//       console.error("Error occurred during mutation:", error);
//     }
//   };
  
//   const getAllUserNames = (): string[] => {
//     if (UsersData.isSuccess && UsersData.data?.content) {
//       return UsersData.data.content
//         .map((user: User) => user.userName)
//         .filter((name: string) => name); // Filter out empty names
//     }
//     return [];
//   };
//   const handleCancel = () => {
//     setOpenPopup(false);
//   };
//   const filteredUsers = useMemo(() => {
//     if (UsersData.isSuccess && UsersData.data?.content) {
//       return UsersData.data.content.filter((user:User) => {

//         const matchesSearch = user.userName
//           .toLowerCase()
//           .includes(searchQuery.toLowerCase());
//         return matchesSearch;
//       });
//     }
//     return []; 
//   }, [UsersData.data, searchQuery]);

  

//   return (
    
//     <div className=" flex w-full flex-col">
//     {/* Header */}
//     <header className="sticky top-0 bg-white shadow z-10">
//     <h1 className="text-2xl text-start font-bold px-5 py-2">Users</h1>
//         <div className="py-4 px-5 flex flex-col w-full items-center justify-between">
//           <div className="flex flex-col sm:flex-row w-full items-center justify-between gap-4">
//           {/* <Dropdown
//               options={["Active", "Inactive"]}
//               className="w-full sm:w-1/4"
//               className2="py-2"
//               onSelect={(e) => {
//                 setIsActive(e === "Active" ? true : false)
//               }}
//               activeOption={isActive ? "Active" : "Inactive"}
//             /> */}
//  <div onClick={() => setStatusDropdownOpen(!statusDropdownOpen)}>
//               <Dropdown
//                 options={["Active", "Inactive", "Deleted"]}
//                 className="w-full sm:w-64" // Increased width
//                 className2="py-3 text-sm" // Adjusted height and font size
//                 onSelect={(e) => {
//                   setIsActive(e === "Active" ? true : false);
//                   setIsDelete(e === "Deleted" ? true : false);
//                   setStatusDropdownOpen(false); // Close dropdown after selection
//                 }}
//                 activeOption={isActive ? "Active" : "Inactive"}
//                 isOpen={statusDropdownOpen}
//                 setIsOpen={setStatusDropdownOpen}
//                 closeOtherDropdown={() => {}}
//               />
//             </div>

//             {/* <div className="w-full sm:w-auto">
//               <SearchBar onClear={() =>{
//                 setSearchQuery("")
//               }} onSearch={(query) => setSearchQuery(query)} />
//             </div> */}
//                  <div className="w-full sm:w-auto">
//               <SearchBar
//                 suggestionInputEnable={{
//                   setActiveValue: (value: string) => {
//                     setSearchQuery(value);
//                   },
//                   activeValue: searchQuery,
//                   enable: true,
//                   loading: UsersData.isLoading,
//                   onSuggestionSelect: (index: number) => {
//                     const allUserNames = getAllUserNames();
//                     if (allUserNames[index]) {
//                       setSearchQuery(allUserNames[index]);
//                     }
//                   },
//                   suggestions: getAllUserNames(),
//                 }}
//                 onClear={() => {
//                   setSearchQuery("");
//                 }}
//                 onSearch={(query) => setSearchQuery(query)}
//               />
//             </div>
//             <button
//               className="bg-primary justify-center gap-1 text-white flex hover:bg-secondary rounded-lg px-4 py-2 text-sm w-full sm:w-auto"
//               onClick={() => {
//                 setOpenPopup(true);
//                 setAddUser(true)
//                 setSelectedUsers({userActiveInactive:true,
//                   userContact:0,
//                   userEmail:'',
//                   userName:"",
//                   userPassword:"",
//                   userID:0,
//                   roles:[{roleName:""}]
//                 })
//               }}
//             >
//           Add <span className="lg:hidden sm:block md:block   xl:block">New</span>
//           </button>
//           </div>
          
//           </div>
//     </header>
    
//     {/* Scrollable Table */}
//     <div className="min-w-full h-full mb-16 md:mb-16 xl:mb-0  overflow-x-auto">
//   {
//     <Table
//     columns={columns as any}
//     loading={UsersData.isLoading}
//     data={filteredUsers.map((item:any) => ({
//       ...item,
//       role:item.roles.length==0?"did not have":item.roles[0].roleName==='ADMIN'?'Admin':'Payment Collector',
//       actions: (
//         <EditAndDeleteButton
//           onDelete={() => {
//             setActiveId(item.userID as number);
//             setDeletPopup(true);
//           }}
//           onEdit={() => handleEdit(item)}
//         />
//         ),
//       }))}
//     />
//   }
// </div>
//     {/* <div className="flex-1 overflow-hidden">
//       <div className="min-w-full  p-1  overflow-hidden"> */}
     
//          {/* <div className="flex-1 overflow-hidden"> */}
//         {/* <div className="min-w-full px-4  overflow-auto">
//           { filteredUsers.length < 0 ? (
//             <p>no data</p>
//           ) : (
//             <Table
//             columns={columns as any}
//             loading={UsersData.isLoading}
//             data={filteredUsers.map((item:any) => ({
//               ...item,
//               role:item.roles[0].roleName==='ADMIN'?'Admin':'Payment Collector',
//               actions: (
//                 <EditAndDeleteButton
//                   onDelete={() => {
//                     setActiveId(item.userID as number);
//                     setDeletPopup(true);
//                   }}
//                   onEdit={() => handleEdit(item)}
//                 />
//                 ),
//               }))}
//             />
//           )}
//         </div> */}
//       {/* </div> */}
//       {/* </div>
//     </div> */}
//     {openPopup ? (
//         <Popup
//           closeButton={true}
//           children={
//             <UserForm
//             disabled={!addUserStatus}
//             isLoading={updateUser.isPending||addUser.isPending}
//               initialData={selectedUsers as any}
//               onSubmit={handleSubmit}
//               onCancel={handleCancel}
//               isOpen={openPopup}
              
//               id={selectedUsers?.userID}
//             />
//           }
//           onClose={() => setOpenPopup(false)}
//         />
//       ) : null}
//       {DeletPopup ? (
//         <Popup
//           children={
//             <DeletePopup
//             isLoading={deleteUser.isPending} 
//               isOpen={DeletPopup}
//               onClose={() => setDeletPopup(false)}
//               onDelete={handleDelete}
//             />
//           }
//           onClose={() => setDeletPopup(false)}
//         />
//       ) : null}

//     {/* Pagination */}
//     <footer
//             className={`xl:sticky   md:fixed  fixed sm:fixed lg:fixed lg:w-full bottom-0 bg-blue-50 shadow z-10 transition-width duration-300 ${
//               sidebarAction ? "w-[calc(100%)]" : "w-full"
//             }`}
//           >
//             <div className="flex justify-center space-x-2">
//               <Pagination
//                 data={currentItems}
//                 ExportFunction={false} // Set to true to show export buttons
//                 currentPage={currentPage}
//                 itemsPerPage={itemsPerPage}
//                 totalItems={totalItems as any}
//                 onPageChange={setCurrentPage}
//                 onPageSizeChange={setItemsPerPage}
//               />
//             </div>
//           </footer>
//     </div>
//   );
// };

// export default UsersCard;



import React, { useState, useMemo } from "react";
import { MdEdit, MdDelete } from "react-icons/md";
import { PropertiesStore } from "../../Store/PagesStore/properties";
import Table from "../Common/Table/main";
import PropertyForm from "../Popups/propertiesPopup";
import Dropdown from "../Common/Dropdown/main";
import SearchBar from "../Common/SearchBar/main";
import Pagination from "../Pagination/main";
import { TriggerStore } from "../../Store";
import { Popup } from "../Common/Popup/main";
import { TenantsStore } from "../../Store/PagesStore/tenents";
import TenantForm from "../Popups/tenantsPopup";
import { UserStore } from "../../Store/PagesStore/users";
import UserForm from "../Popups/users";
import DeletePopup from "../Popups/deletePopup";
import { useUsers } from "../../hook/useUsers";
import { User } from "../../hook/types/users";

type UserInfo = {
  userName: string;
  active: boolean;
  userID: string;
  contactNumber: string;
  emailID: string;
  role: string;
  address: string;
  createdBy: string;
  password: string;
};

const EditAndDeleteButton: React.FC<{
  onEdit: () => void;
  onDelete: () => void;
}> = ({ onEdit, onDelete }) => {
  return (
    <div className="flex space-x-2">
      <button className="btn btn-secondary" onClick={onEdit}>
        <MdEdit className="h-5 w-5 hover:text-primary" />
      </button>
      <button className="btn btn-danger" onClick={onDelete}>
        <MdDelete className="h-5 w-5 hover:text-red-500" />
      </button>
    </div>
  );
};

const UsersCard: React.FC = () => {
  const { Users, addUser, deleteUser, updateUser } = useUsers()
  const { sidebarAction, sidebartrigger } = TriggerStore((state) => state);
  const { editUser } = UserStore((state) => state);

  const [openPopup, setOpenPopup] = useState(false);
  const [DeletPopup, setDeletPopup] = useState(false);
  const [activeId, setActiveId] = useState<number>(0);
  const [isActive, setIsActive] = useState(true);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [addUserStatus, setAddUser] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedUsers, setSelectedUsers] = useState<User | null>(null);

  const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
  
  // State for pagination
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const UsersData = Users({ isActive: isActive, delete: isDelete, page: currentPage, size: itemsPerPage });

  const columns = [
    { key: "userName", title: "User Name", type: "text" },
    { key: "userID", title: "User ID", type: "text" },
    { key: "userContact", title: "Contact Number", type: "text" },
    { key: "userEmail", title: "Email ID", type: "email" },
    { key: "role", title: "Role", type: "text" },
    { key: "userPassword", title: "Password", type: "password" },
    { key: "actions", title: "Actions", type: "component" },
  ];

  // Filter users based on search query
  const filteredUsers = useMemo(() => {
    if (UsersData.isSuccess && UsersData.data?.content) {
      return UsersData.data.content.filter((user: User) => {
        const matchesSearch = user.userName
          .toLowerCase()
          .includes(searchQuery.toLowerCase());
        return matchesSearch;
      });
    }
    return []; 
  }, [UsersData.data, searchQuery]);

  // Calculate pagination values based on actual filtered data
  const totalItems = UsersData.data?.totalElements || 0;
  const currentItems = filteredUsers;

  const handleEdit = (user: User) => {
    setAddUser(false)
    setSelectedUsers(user);
    setOpenPopup(true);
  };

  const handleDelete = async() => {
    await deleteUser.mutateAsync(activeId).then(() =>{
      setDeletPopup(false);
    });
  };

  const handleSubmit = async (formData: User) => {
    try {      
      if (addUserStatus) {
        await addUser.mutateAsync({
          userContact: formData.userContact,
          userEmail: formData.userEmail,
          userName: formData.userName,
          userPassword: formData.userPassword,
          roles: formData.roles[0].roleName,
          userActiveInactive: formData.userActiveInactive, 
        });
  
        setAddUser(false);
        setOpenPopup(false);
      } else {
        await updateUser.mutateAsync({
          id: formData.userID as any,
          updatedUser: {
            userContact: formData.userContact,
            userEmail: formData.userEmail,
            userName: formData.userName,
            userPassword: formData.userPassword,
            roles: formData.roles[0].roleName,
            userActiveInactive: formData.userActiveInactive,
          },
        });
  
        setOpenPopup(false);
      }
  
      setAddUser(false);
    } catch (error) {
      console.error("Error occurred during mutation:", error);
    }
  };
  
  const getAllUserNames = (): string[] => {
    if (UsersData.isSuccess && UsersData.data?.content) {
      return UsersData.data.content
        .map((user: User) => user.userName)
        .filter((name: string) => name);
    }
    return [];
  };
  
  const handleCancel = () => {
    setOpenPopup(false);
  };

  return (
    <div className="flex w-full flex-col h-full">
      {/* Header */}
      <header className="sticky top-0 bg-white shadow z-10">
        <h1 className="text-2xl text-start font-bold px-5 py-2">Users</h1>
        <div className="py-4 px-5 flex flex-col w-full items-center justify-between">
          <div className="flex flex-col sm:flex-row w-full items-center justify-between gap-4">
            <div onClick={() => setStatusDropdownOpen(!statusDropdownOpen)}>
              <Dropdown
                options={["Active", "Inactive", "Deleted"]}
                className="w-full sm:w-64"
                className2="py-3 text-sm"
                onSelect={(e) => {
                  setIsActive(e === "Active" ? true : false);
                  setIsDelete(e === "Deleted" ? true : false);
                  setStatusDropdownOpen(false);
                  setCurrentPage(0); // Reset to first page when status changes
                }}
                activeOption={isActive ? "Active" : isDelete ? "Deleted" : "Inactive"}
                isOpen={statusDropdownOpen}
                setIsOpen={setStatusDropdownOpen}
                closeOtherDropdown={() => {}}
              />
            </div>

            <div className="w-full sm:w-auto">
              {/* <SearchBar
                suggestionInputEnable={{
                  setActiveValue: (value: string) => {
                    setSearchQuery(value);
                  },
                  activeValue: searchQuery,
                  enable: true,
                  loading: UsersData.isLoading,
                  onSuggestionSelect: (index: number) => {
                    const allUserNames = getAllUserNames();
                    if (allUserNames[index]) {
                      setSearchQuery(allUserNames[index]);
                    }
                  },
                  suggestions: getAllUserNames(),
                }}
                onClear={() => {
                  setSearchQuery("");
                }}
                onSearch={(query) => {
                  setSearchQuery(query);
                  setCurrentPage(0); // Reset to first page when search changes
                }}
              /> */}
              <SearchBar
  suggestionInputEnable={{
    setActiveValue: (value: string) => {
      setSearchQuery(value);
    },
    activeValue: searchQuery,
    enable: true,
    loading: UsersData.isLoading,
    onSuggestionSelect: (index: number) => {
      const allUserNames = getAllUserNames();
      
      // Filter user names based on current search query
      const filteredUserNames = allUserNames.filter(name =>
        name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      
      // Get the selected user name from the filtered list
      if (index >= 0 && index < filteredUserNames.length) {
        setSearchQuery(filteredUserNames[index]);
      }
    },
    suggestions: getAllUserNames(),
  }}
  onClear={() => {
    setSearchQuery("");
  }}
  onSearch={(query) => {
    setSearchQuery(query);
    setCurrentPage(0); // Reset to first page when search changes
  }}
/>
            </div>
            
            <button
              className="bg-primary justify-center gap-1 text-white flex hover:bg-secondary rounded-lg px-4 py-2 text-sm w-full sm:w-auto"
              onClick={() => {
                setOpenPopup(true);
                setAddUser(true)
                setSelectedUsers({
                  userActiveInactive: true,
                  userContact: 0,
                  userEmail: '',
                  userName: "",
                  userPassword: "",
                  userID: 0,
                  roles: [{roleName: ""}]
                })
              }}
            >
              Add <span className="lg:hidden sm:block md:block xl:block">New</span>
            </button>
          </div>
        </div>
      </header>
    
      {/* Scrollable Table */}
      <div className="flex-1 overflow-hidden">
        <div className="h-full overflow-auto">
          <Table
            columns={columns as any}
            loading={UsersData.isLoading}
            data={currentItems.map((item: any) => ({
              ...item,
              role: item.roles.length === 0 ? "did not have" : item.roles[0].roleName === 'ADMIN' ? 'Admin' : 'Payment Collector',
              actions: (
                <EditAndDeleteButton
                  onDelete={() => {
                    setActiveId(item.userID as number);
                    setDeletPopup(true);
                  }}
                  onEdit={() => handleEdit(item)}
                />
              ),
            }))}
          />
        </div>
      </div>

      {openPopup ? (
        <Popup
          closeButton={true}
          children={
            <UserForm
              disabled={!addUserStatus}
              isLoading={updateUser.isPending || addUser.isPending}
              initialData={selectedUsers as any}
              onSubmit={handleSubmit}
              onCancel={handleCancel}
              isOpen={openPopup}
              id={selectedUsers?.userID}
            />
          }
          onClose={() => setOpenPopup(false)}
        />
      ) : null}
      
      {DeletPopup ? (
        <Popup
          children={
            <DeletePopup
              isLoading={deleteUser.isPending} 
              isOpen={DeletPopup}
              onClose={() => setDeletPopup(false)}
              onDelete={handleDelete}
            />
          }
          onClose={() => setDeletPopup(false)}
        />
      ) : null}

      {/* Pagination */}
      <footer className={`sticky bottom-0 bg-blue-50 shadow z-10 transition-width duration-300 ${sidebarAction ? "w-[calc(100%)]" : "w-full"}`}>
        <div className="flex justify-center space-x-2 p-2">
          <Pagination
            data={currentItems}
            ExportFunction={false}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            totalItems={totalItems}
            onPageChange={setCurrentPage}
            onPageSizeChange={setItemsPerPage}
          />
        </div>
      </footer>
    </div>
  );
};

export default UsersCard;
